import routeSheetComponent from './routeSheet.component';
import Print from './print'

let routeSheetModule = angular.module('routeSheet', [
    Print
  ])

  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/routeSheet');

    $stateProvider
      .state('routeSheet', {
        url: '/route-sheet',
        component: 'routeSheet',
        data: {
          requireLogin: true,
          requireACL: 'route_sheet.all'          
        },
        parent: 'app',
      });
  })

  .component('routeSheet', routeSheetComponent)

  .name;

export default routeSheetModule;


// WEBPACK FOOTER //
// ./client/app/components/routeSheet/index.js